// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"0fcbf2c4","340":"c6f28f3e","401":"0b218546","430":"e0e56d13","484":"0a99f08a","601":"40e464a6","649":"0c17a41c","653":"d889369b","688":"4d2cad36","783":"89f860d9"}[chunkId] + ".chunk.js";
};